var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRequest = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.226 1.548a.657.657 0 0 1 0 1.314h-5.11a.803.803 0 0 0-.803.803v10.219a.803.803 0 0 0 .803.803h10.219a.805.805 0 0 0 .803-.803v-5.11a.657.657 0 0 1 1.314 0v5.11A2.117 2.117 0 0 1 12.335 16H2.116A2.117 2.117 0 0 1 0 13.884V3.665a2.12 2.12 0 0 1 2.116-2.117zM13.795 0a2.206 2.206 0 0 1 1.56 3.765L8.42 10.698a.66.66 0 0 1-.305.173l-2.92.73a.658.658 0 0 1-.796-.796l.73-2.92a.66.66 0 0 1 .173-.305L12.235.646A2.2 2.2 0 0 1 13.795 0m0 1.313a.9.9 0 0 0-.63.262L6.359 8.38l-.42 1.681 1.681-.42 6.805-6.805a.893.893 0 0 0-.63-1.523"
  })));
};
export default SvgRequest;